import React, { useState, useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import { DashboardApi } from "../../../api/DashboardApi";
import LatestPlayActivityCard from "./LatestPlayActivityCard";

// Configurable polling interval in milliseconds
const POLL_INTERVAL = 60000;   // 1 minutes

const MAIN_FONT = "Noto Sans TC";

export default function PlayActivityPanel() {
    const [activities, setActivities] = useState([]);
    const [skillNameMap, setSkillNameMap] = useState({});
    const sinceTimeRef = useRef("");
    const skillNameMapRef = useRef({});

    // Initial load: fetch skill name map first, then activities
    useEffect(() => {
        const init = async () => {
            try {
                const nameMap = await DashboardApi.getSkillNameMapping();
                const resolvedMap = nameMap || {};
                setSkillNameMap(resolvedMap);
                skillNameMapRef.current = resolvedMap;
            } catch (err) {
                console.error("PlayActivityPanel getSkillNameMapping error", err);
            }

            try {
                const result = await DashboardApi.getLatestPlayActivity("");
                const items = result || [];
                if (items.length > 0) {
                    // Sort descending (latest first) and store
                    const sorted = [...items].sort(
                        (a, b) => new Date(b.created_at) - new Date(a.created_at)
                    );
                    setActivities(sorted);
                    sinceTimeRef.current = sorted[0].created_at;
                }
            } catch (err) {
                console.error("PlayActivityPanel init error", err);
            }
        };
        init();
    }, []);

    // Polling for new activities
    useEffect(() => {
        const timer = setInterval(async () => {
            try {
                const result = await DashboardApi.getLatestPlayActivity(
                    sinceTimeRef.current
                );
                const items = result || [];
                if (items.length === 0) return; // No new items, skip

                // Place the latest items at top and deduplicate with existing ones
                // If the list over 40 items, remove the oldest ones (the items at the end) to prevent memory leak

                let newList = [...activities];
                items.forEach((item) => {
                    if (!newList.some((a) => a.id === item.id)) {
                        newList.unshift(item); // Add new item to the top
                    }
                });
                if (newList.length > 40) {
                    newList = newList.slice(0, 40); // Keep only the latest 40 items
                }
                
                setActivities(newList); 
                sinceTimeRef.current = newList[0].created_at;

                // setActivities(newList);
                
                // sinceTimeRef.current = sorted[0].created_at;
                // if (items.length > 0) {
                //     const sorted = [...items].sort(
                //         (a, b) => new Date(b.created_at) - new Date(a.created_at)
                //     );
                //     setActivities((prev) => {
                //         // Prepend new items, deduplicate by id
                //         const existingIds = new Set(prev.map((a) => a.id));
                //         const newItems = sorted.filter((a) => !existingIds.has(a.id));
                //         return [...newItems, ...prev];
                //     });
                //     sinceTimeRef.current = sorted[0].created_at;
                // }
            } catch (err) {
                console.error("PlayActivityPanel poll error", err);
            }
        }, POLL_INTERVAL);
        return () => clearInterval(timer);
    }, []);

    return (
        <Box
            sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                backgroundImage: `
                    radial-gradient(ellipse at top, #0D1B3E 0%, #060D1F 70%),
                    repeating-linear-gradient(0deg, transparent, transparent 39px, rgba(0,150,255,0.06) 40px),
                    repeating-linear-gradient(90deg, transparent, transparent 39px, rgba(0,150,255,0.06) 40px)
                `,
                p: 2,
                boxSizing: "border-box",
                overflow: "hidden",
            }}
        >


            {/* Scrollable card list */}
            <Box
                sx={{
                    flex: 1,
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.5,
                    pr: 0.5,
                    "&::-webkit-scrollbar": { width: "4px" },
                    "&::-webkit-scrollbar-track": { background: "transparent" },
                    "&::-webkit-scrollbar-thumb": {
                        background: "rgba(130, 60, 255, 0.5)",
                        borderRadius: "4px",
                    },
                }}
            >
                {activities.length === 0 && (
                    <Typography
                        sx={{
                            fontFamily: MAIN_FONT,
                            color: "#8888AA",
                            fontSize: "16px",
                            textAlign: "center",
                            mt: 4,
                        }}
                    >
                        未有資料
                    </Typography>
                )}

                {activities.map((item) => (
                    <Box key={item.id} sx={{ flexShrink: 0 }}>
                        <LatestPlayActivityCard
                            data={item}
                            skillNameMap={skillNameMap}
                        />
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
